import { useMutation, useQueryClient } from "@tanstack/react-query";
import { $journalApi } from "@entities/journal/fetch/fetch-client.ts";
import { createSectionTwoRecord } from "../api/create-section-two-record.ts";
import { mapSectionTwoRequest } from "./map-section-two-request";

interface IUseCreateSectionTwoRecord {
  sectionTwoId: string;
}

interface IRequest {
  mainJournalId: string;
  section2Id: string;
  section2ListId: string;
  specialJournalName: string;
  specialJournalDate: string;
  journalKeepersList?: Array<any>;
  dateHandover?: string | null;
  signer: string;
  file?:
    | { file?: File | null | undefined; id?: string | null | undefined }
    | null
    | undefined;
}

export function useCreateSectionTwoRecord({
  sectionTwoId,
}: IUseCreateSectionTwoRecord) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: IRequest) => {
      return createSectionTwoRecord({
        sectionTwoId,
        updateSectionTwoRequest: mapSectionTwoRequest(data),
        file: data.file,
      });
    },
    onSuccess: async () =>
      queryClient.invalidateQueries({
        queryKey: $journalApi.queryOptions(
          "get",
          "/api/v1/journals/section-two/{sectionTwoId}",
          { params: { path: { sectionTwoId } } },
        ).queryKey,
      }),
  });
}
